export default {
    table: {
        tableWrapper: '',
        tableBodyClass: '',
        tableClass: 'table',
        loadingClass: 'loading',
        ascendingIcon: 'icon',
        descendingIcon: 'icon',
        ascendingClass: 'sorted-asc',
        descendingClass: 'sorted-desc',
        sortableIcon: 'icon',
        handleIcon: 'icon',
    },
  
    pagination: {
        wrapperClass: 'pagination',
        activeClass: 'active',
        disabledClass: 'disabled',
        pageClass: 'pagination-item',
        linkClass: 'pagination-item',
        paginationClass: '',
        paginationInfoClass: 'pagination-info',
        dropdownClass: 'pagination-dropdown',
        icons: {
            first: 'icon first',
            prev: 'icon prev',
            next: 'icon next',
            last: 'icon last',
        }
    },
  
    paginationInfo: {
        infoClass: 'pagination-info',
    }
}
